// Blog post data with slugs for individual pages
export interface BlogPost {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  date: string;
  readTime: string;
  content: string;
}

export const posts: BlogPost[] = [
  {
    slug: "build-professional-learning-path",
    title: "كيف تبني مسارًا تعليميًا احترافيًا",
    category: "تجربة التعلم",
    excerpt: "نصائح عملية لتصميم مسارات تعليمية تزيد الالتزام وتحسن النتائج.",
    date: "يناير 2026",
    readTime: "5 دقائق",
    content: `
      <h2>مقدمة</h2>
      <p>بناء مسار تعليمي احترافي يتطلب تخطيطًا دقيقًا وفهمًا عميقًا لاحتياجات المتعلمين. في هذا المقال، سنستعرض أهم الخطوات لتصميم مسار تعليمي فعّال.</p>
      
      <h2>1. تحديد الأهداف التعليمية</h2>
      <p>قبل البدء في إنشاء أي محتوى، يجب تحديد الأهداف التعليمية بوضوح. ماذا سيتعلم الطالب في نهاية المسار؟ ما المهارات التي سيكتسبها؟</p>
      <ul>
        <li>حدد المخرجات التعليمية المتوقعة</li>
        <li>اربط كل درس بهدف محدد</li>
        <li>استخدم أفعال قابلة للقياس (يفهم، يطبق، يحلل)</li>
      </ul>
      
      <h2>2. تقسيم المحتوى إلى وحدات</h2>
      <p>قسّم المحتوى إلى وحدات صغيرة ومترابطة. كل وحدة يجب أن تركز على مفهوم أو مهارة واحدة.</p>
      
      <h2>3. التدرج في الصعوبة</h2>
      <p>ابدأ بالمفاهيم الأساسية ثم انتقل تدريجيًا إلى المفاهيم الأكثر تعقيدًا. هذا يساعد المتعلم على بناء معرفته بشكل متسلسل.</p>
      
      <h2>4. إضافة التقييمات</h2>
      <p>أضف اختبارات قصيرة بعد كل وحدة لقياس فهم الطالب. التقييم المستمر يساعد في تحديد نقاط الضعف مبكرًا.</p>
      
      <h2>الخلاصة</h2>
      <p>المسار التعليمي الناجح هو الذي يجمع بين المحتوى الجيد والتنظيم المحكم والتقييم المستمر. ابدأ بالتخطيط الجيد وستجني ثمار جهدك.</p>
    `,
  },
  {
    slug: "measuring-educational-impact-lms",
    title: "قياس الأثر التعليمي في منصات LMS",
    category: "التحليلات",
    excerpt: "مؤشرات الأداء الأهم لمتابعة تقدّم الطلاب وفاعلية المحتوى.",
    date: "ديسمبر 2025",
    readTime: "7 دقائق",
    content: `
      <h2>أهمية قياس الأثر التعليمي</h2>
      <p>لا يمكنك تحسين ما لا تقيسه. قياس الأثر التعليمي يساعدك على فهم مدى فاعلية محتواك وتحديد فرص التحسين.</p>
      
      <h2>مؤشرات الأداء الرئيسية (KPIs)</h2>
      
      <h3>1. معدل إكمال الدورات</h3>
      <p>نسبة الطلاب الذين أكملوا الدورة مقارنة بمن بدأوها. معدل الإكمال المنخفض قد يشير إلى مشاكل في المحتوى أو طوله.</p>
      
      <h3>2. درجات الاختبارات</h3>
      <p>متوسط درجات الطلاب في الاختبارات يعكس مدى فهمهم للمحتوى.</p>
      
      <h3>3. وقت التفاعل</h3>
      <p>كم يقضي الطالب في كل درس؟ الوقت الطويل جدًا قد يعني صعوبة المحتوى، والقصير جدًا قد يعني عدم الاهتمام.</p>
      
      <h3>4. معدل التراجع</h3>
      <p>في أي نقطة يتوقف الطلاب عن المتابعة؟ هذا يساعدك على تحديد الدروس التي تحتاج تحسينًا.</p>
      
      <h2>أدوات التحليل</h2>
      <p>استخدم لوحات التحكم التحليلية في منصتك لمراقبة هذه المؤشرات بانتظام. في تبيان، نوفر تحليلات مفصلة لكل معلم.</p>
      
      <h2>اتخاذ القرارات بناءً على البيانات</h2>
      <p>لا تكتفِ بجمع البيانات، بل حللها واتخذ قرارات لتحسين تجربة التعلم.</p>
    `,
  },
  {
    slug: "building-knowledge-community",
    title: "أفضل الممارسات لبناء مجتمع معرفي",
    category: "المجتمع",
    excerpt: "كيف تحافظ على تفاعل صحي وأسئلة عالية الجودة داخل الدورات.",
    date: "نوفمبر 2025",
    readTime: "6 دقائق",
    content: `
      <h2>قوة المجتمع التعليمي</h2>
      <p>التعلم ليس نشاطًا فرديًا فقط. المجتمع التعليمي القوي يضاعف قيمة المحتوى ويحسن تجربة التعلم.</p>
      
      <h2>1. وضع قواعد واضحة</h2>
      <p>ابدأ بوضع قواعد واضحة للتفاعل. ما المقبول وما غير المقبول؟ هذا يساعد على الحفاظ على بيئة محترمة.</p>
      <ul>
        <li>احترام الآراء المختلفة</li>
        <li>تجنب الإساءة الشخصية</li>
        <li>التركيز على الموضوع</li>
      </ul>
      
      <h2>2. تشجيع الأسئلة</h2>
      <p>خلق بيئة آمنة للأسئلة. لا يوجد سؤال غبي. شجع الطلاب على السؤال وكافئ الأسئلة الجيدة.</p>
      
      <h2>3. التفاعل المستمر</h2>
      <p>كن حاضرًا في المجتمع. رد على الأسئلة، شارك في النقاشات، واعترف بمساهمات الأعضاء.</p>
      
      <h2>4. المحتوى الذي ينشئه المستخدمون</h2>
      <p>شجع الطلاب على مشاركة ملخصاتهم وملاحظاتهم. هذا يثري المجتمع ويساعد الآخرين.</p>
      
      <h2>5. الإشراف الفعال</h2>
      <p>راقب النقاشات وتدخل عند الحاجة. أزل المحتوى غير المناسب بسرعة.</p>
      
      <h2>الخلاصة</h2>
      <p>المجتمع المعرفي الصحي يتطلب جهدًا مستمرًا، لكنه يستحق ذلك. ابدأ ببناء الثقة والاحترام المتبادل.</p>
    `,
  },
  {
    slug: "interactive-quran-teaching-methods",
    title: "أساليب تفاعلية لتعليم القرآن الكريم",
    category: "التجويد والقراءات",
    excerpt: "طرق مبتكرة لجعل حفظ القرآن وتجويده تجربة ممتعة وفعالة للأطفال والكبار.",
    date: "أكتوبر 2025",
    readTime: "8 دقائق",
    content: `
      <h2>تحديات تعليم القرآن</h2>
      <p>تعليم القرآن الكريم يحتاج إلى صبر ومنهجية. الأساليب التقليدية فعالة، لكن إضافة عنصر التفاعل يمكن أن يحسن النتائج.</p>
      
      <h2>1. التكرار المتدرج</h2>
      <p>استخدم نظام التكرار المتباعد (Spaced Repetition) لتثبيت الحفظ. راجع ما حفظته بفواصل زمنية متزايدة.</p>
      
      <h2>2. التسميع التفاعلي</h2>
      <p>بدلاً من التسميع التقليدي، جرب:</p>
      <ul>
        <li>التسميع الجماعي</li>
        <li>المسابقات الودية</li>
        <li>تسجيل التلاوة ومقارنتها</li>
      </ul>
      
      <h2>3. ربط الآيات بمعانيها</h2>
      <p>فهم المعنى يسهل الحفظ. اشرح معاني الآيات بطريقة مبسطة قبل الحفظ.</p>
      
      <h2>4. استخدام التقنية</h2>
      <p>تطبيقات القرآن الحديثة توفر ميزات رائعة مثل التلاوة البطيئة وتكرار الآيات.</p>
      
      <h2>5. المتابعة المستمرة</h2>
      <p>حدد جدولاً منتظمًا للمراجعة. الاستمرارية أهم من الكثافة.</p>
    `,
  },
  {
    slug: "arabic-language-digital-age",
    title: "اللغة العربية في العصر الرقمي",
    category: "اللغة العربية",
    excerpt: "كيف نحافظ على جمال اللغة العربية ونطورها في عالم التقنية المتسارع.",
    date: "سبتمبر 2025",
    readTime: "5 دقائق",
    content: `
      <h2>التحديات الرقمية</h2>
      <p>اللغة العربية تواجه تحديات في العصر الرقمي، من انتشار العامية إلى ضعف المحتوى العربي الجيد.</p>
      
      <h2>فرص التقنية</h2>
      <p>لكن التقنية توفر أيضًا فرصًا عظيمة:</p>
      <ul>
        <li>منصات التعلم الإلكتروني</li>
        <li>تطبيقات تعلم اللغة</li>
        <li>المحتوى التفاعلي</li>
      </ul>
      
      <h2>دورنا في تبيان</h2>
      <p>نسعى لتقديم محتوى عربي عالي الجودة يجمع بين الأصالة والحداثة.</p>
      
      <h2>نصائح للمتعلمين</h2>
      <p>اقرأ بالعربية الفصحى يوميًا، حتى لو كانت مقالة قصيرة. الممارسة المستمرة هي المفتاح.</p>
    `,
  },
  {
    slug: "effective-online-teaching-tips",
    title: "نصائح للتدريس الفعال عبر الإنترنت",
    category: "للمعلمين",
    excerpt: "دليل شامل للمعلمين لتقديم دروس مؤثرة ومحفزة في البيئة الافتراضية.",
    date: "أغسطس 2025",
    readTime: "10 دقائق",
    content: `
      <h2>اختلاف التدريس عبر الإنترنت</h2>
      <p>التدريس عبر الإنترنت يختلف عن التدريس الحضوري. يحتاج المعلم إلى مهارات وأدوات مختلفة.</p>
      
      <h2>1. التحضير الجيد</h2>
      <p>حضّر درسك مسبقًا. جهز الشرائح والمواد واختبر التقنية قبل الدرس.</p>
      
      <h2>2. التفاعل المستمر</h2>
      <p>لا تكتفِ بالشرح. اطرح أسئلة، استخدم الاستطلاعات، واطلب من الطلاب المشاركة.</p>
      
      <h2>3. تقسيم الوقت</h2>
      <p>قسّم الدرس إلى فقرات قصيرة (15-20 دقيقة) مع فواصل تفاعلية.</p>
      
      <h2>4. استخدام الوسائط</h2>
      <p>نوّع بين الشرح والصور والفيديوهات والأنشطة التفاعلية.</p>
      
      <h2>5. المتابعة</h2>
      <p>تابع مع طلابك بعد الدرس. أرسل ملخصًا ووفر قنوات للأسئلة.</p>
      
      <h2>6. التطوير المستمر</h2>
      <p>اطلب التغذية الراجعة من طلابك وحسّن أداءك باستمرار.</p>
    `,
  },
];
